import { createContext } from "react";

export const MinuteBookContext = createContext({});
